import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from 'axios';

const StockWastageListModal = ({ show, onClose }) => {
    const [wastageList, setWastageList] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // Fetch wastage list from API
    useEffect(() => {
        if (show) {
            axios
                .get(`${baseURL}/storage-wastage`)
                .then((res) => {
                    if (res.data && res.data.data) {
                        setWastageList(res.data.data);
                    }
                })
                .catch((err) => {
                    console.error('Error fetching wastage list:', err);
                });
        }
    }, [show]);

    return (
        <Modal show={show} size="lg" onHide={onClose} >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Stock Wastage Details</h3>
                    <Button variant="" type="button" className="close px-6 py-1" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div 
    className="table-container" 
    style={{ maxHeight: '600px', overflowY: 'auto' }}
>
    <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
        <thead>
            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                <th className="min-w-50px text-start">Date</th>
                <th className="min-w-100px text-start">Raw Material</th>
                <th className="min-w-80px text-center">Wastage Stock</th>
            </tr>
        </thead>
        <tbody className="text-gray-600 fw-semibold fs-7">
            {wastageList.length > 0 ? (
                wastageList.map((item) => (
                    <tr key={item.sno}>
                        <td className="text-black">{item.storagewastage_date}</td>
                        <td className="text-black text-start">
                            <div>{item.rawmaterial?.rawmaterial_name}</div>
                            <div style={{ fontSize: '0.85rem', color: '#555' }}>{item.storageroom?.storageroom_name}</div>
                        </td>
                        <td className="text-black text-center">
                            {parseFloat(item.storagewastage_quantity)} {item.unit?.unitslug_name}
                        </td>
                    </tr>
                ))
            ) : (
                <tr>
                    <td colSpan={3} className="text-center text-black">
                        No wastage records found.
                    </td>
                </tr>
            )}
        </tbody>
    </table>
                    </div> 
                </div>
            </div>
        </Modal>
    );
};

export default StockWastageListModal;
